import * as React from 'react'

import { Modal, ModalProps } from '@thg-commerce/gravity-elements'
import { MarketedSpecialOffer } from '@thg-commerce/gravity-patterns/MarketedSpecialOfferSummary'
import { styled, Text } from '@thg-commerce/gravity-theme'

const Title = styled.p`
  ${Text('large1', 'alternate')}
`

export interface MarketedSpecialOfferModalProps {
  title: string
  description?: string
  cta?: {
    text: string
    href: string
    openExternally: boolean
    noFollow: boolean
  }
  freeGiftProduct?: { images; title; price }
  i18nText: {
    closeI18nText: ModalProps['i18nText']
    freeGiftMessage?: string
  }
  onClose: () => void
  open: boolean
  shouldRemoveScrollLock?: boolean
}

export const MarketedSpecialOfferModal = (
  props: MarketedSpecialOfferModalProps,
) => {
  const { title, ...specialOfferProps } = props
  return (
    <Modal
      i18nText={props.i18nText.closeI18nText}
      open={props.open}
      gridColSpan={[12, 12, 10, 6]}
      onClose={props.onClose}
      data-testid="marketed-special-offer-modal"
      verticalAlignment="center"
      showHeader={true}
      stickyHeader={true}
      shouldRemoveScrollLock={props.shouldRemoveScrollLock}
    >
      <Title>{props.title}</Title>
      <MarketedSpecialOffer
        {...specialOfferProps}
        i18nFreeGiftMessage={props.i18nText.freeGiftMessage}
        imageWidth={196}
        direction="row"
      />
    </Modal>
  )
}
